export const DEFAULT_SECTION_COLOR = "#059669";

export const normalizeHex = (value) => {
  const text = String(value || "").trim();
  const match = text.match(/^#?([0-9a-fA-F]{6})$/);
  if (!match) return "";
  return `#${match[1].toUpperCase()}`;
};

export const isMissingColorColumn = (error) => {
  if (!error) return false;
  const code = String(error.code || "");
  const message = String(error.message || "").toLowerCase();
  return code === "42703" && message.includes("color");
};

export const getVenueSectionColor = (sections = [], parentName) => {
  const name = String(parentName || "").trim();
  if (!name) return "";
  const parent = (sections || []).find(
    (section) => !section.parent_section_id && String(section.name || "").trim() === name
  );
  return normalizeHex(parent?.color);
};

export const buildSectionColorOverrides = (tiers = []) => {
  const overrides = {};
  (tiers || []).forEach((tier) => {
    const section = String(tier.section || "").trim();
    const color = normalizeHex(tier.color);
    if (!section || !color || overrides[section]) return;
    overrides[section] = color;
  });
  return overrides;
};

export const getSnapshotSectionColor = (snapshot, sectionName) => {
  const name = String(sectionName || "").trim();
  if (!name || !snapshot?.sections) return "";
  const section = snapshot.sections.find((row) => String(row.name || "").trim() === name);
  return normalizeHex(section?.color || section?.pages?.[0]?.color);
};

export const resolveSectionColor = ({ tierColor, snapshotColor, venueColor } = {}) =>
  normalizeHex(tierColor) || normalizeHex(snapshotColor) || normalizeHex(venueColor) || "";

export const availableSeatFillStyle = (hex) => {
  const color = normalizeHex(hex) || DEFAULT_SECTION_COLOR;
  return {
    backgroundColor: `${color}33`,
    borderColor: `${color}99`,
  };
};

export const hexToRgb = (value) => {
  const hex = normalizeHex(value);
  if (!hex) return null;
  return {
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16),
  };
};

export const resolveTicketSectionColor = ({ tier, event, venueSections = [] } = {}) => {
  let snapshot = event?.seat_layout_snapshot || null;
  if (typeof snapshot === "string") {
    try {
      snapshot = JSON.parse(snapshot);
    } catch {
      snapshot = null;
    }
  }

  const sectionName = String(tier?.section || tier?.name || "").trim();
  const venueRows = (venueSections || []).filter(
    (section) => !event?.venue_id || section.venue_id === event.venue_id
  );

  return resolveSectionColor({
    tierColor: tier?.color,
    snapshotColor: getSnapshotSectionColor(snapshot, sectionName),
    venueColor: getVenueSectionColor(venueRows, sectionName),
  });
};

export const applySectionColorsToSnapshot = (snapshot, sectionColors = {}) => {
  if (!snapshot) return snapshot;
  return {
    ...snapshot,
    sections: (snapshot.sections || []).map((section) => {
      const color =
        normalizeHex(sectionColors[section.name]) ||
        normalizeHex(section.color) ||
        normalizeHex(section.pages?.[0]?.color) ||
        "";
      return {
        ...section,
        color,
        pages: (section.pages || []).map((page) => ({ ...page, color })),
      };
    }),
  };
};
